import { render } from "./SimpleContainerV2.vue?vue&type=template&id=3f6e3159&ts=true"
import script from "./SimpleContainerV2.vue?vue&type=script&lang=ts"
export * from "./SimpleContainerV2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__